import './AdvertiserForm.css';

import type { FormInstance }    from 'antd';
import React                    from 'react';
import { observer }             from 'mobx-react';
import { Button }               from 'antd';
import { Col }                  from 'antd';
import { Form }                 from 'antd';
import { Input }                from 'antd';
import Row                      from 'components/App/Row';
import { Upload }               from 'antd';
import { UploadOutlined }       from '@ant-design/icons';
import AdvertiserLogoMediaModel from 'models/AdvertiserLogoMediaModel';
import FormattedMessageWrapper  from 'components/App/FormattedMessageWrapper';
import AdvertiserModel          from 'models/AdvertiserModel';
import handleFormError          from 'utils/handleFormError';
import { messageSuccessIntl }   from 'utils/messageIntl';
import { messageErrorIntl }     from 'utils/messageIntl';
import { AppFormComponent }     from 'components/App/AppForm';

interface AdvertiserFormProps {
  model: AdvertiserModel;
}

@observer
class AdvertiserForm extends AppFormComponent<AdvertiserFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state: { logoList: any[] } = {
    logoList: [],
  };

  public componentDidMount() {
    this.initLogoList();
  }

  public componentDidUpdate(prevProps: AdvertiserFormProps) {
    if (prevProps.model.id !== this.props.model.id) {
      this.initLogoList();
      this.formRef.current?.resetFields();
    }
  }

  public render() {
    const { model } = this.props;

    return (
      <Form
        className="antd-form-custom-style modal-form"
        initialValues={{
          initialValue: model.get('logo.@id'),
          link: model.get('link'),
          name: model.get('name'),
        }}
        ref={this.formRef}
      >
        <Row>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Nom" />}
              labelCol={{ span: 24 }}
              name="name"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Nom manquant" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Lien" />}
              labelCol={{ span: 24 }}
              name="link"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Lien manquant" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Logo (170 px X 170 px, taille max. 5 Mo)" />}
              labelCol={{ span: 24 }}
              name="logo"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Logo manquant" />,
                  required: true,
                },
              ]}
            >
              <Upload
                beforeUpload={file => {
                  this.beforeUpload(file);
                  return false;
                }}
                defaultFileList={this.state.logoList}
                fileList={this.state.logoList}
                onRemove={() => this.onRemove()}
              >
                <Button
                  htmlType="button"
                  icon={<UploadOutlined />}
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <FormattedMessageWrapper id="Ajouter un fichier" />
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { model } = this.props;

    try {
      const values = await this.formRef.current?.validateFields();
      await model.patch(values);
      messageSuccessIntl("Annonceur enregistré !");
      this.formRef.current?.resetFields();
      this.setState({ logoList: [] });
      this.props.onSuccess?.();
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };

  private beforeUpload = (file: any) => {
    this.setState({ logoList: [file] });

    const advertiserLogoMediaModel = new AdvertiserLogoMediaModel();
    advertiserLogoMediaModel.set('file', file);
    advertiserLogoMediaModel.save().then(
      (advertiserLogoMedia: AdvertiserLogoMediaModel) => {
        this.formRef.current?.setFieldsValue({
          logo: advertiserLogoMedia.data['@id'],
        });
      },
      () => {
        messageErrorIntl("Le chargement du fichier a échoué.");
        this.setState({ logoList: [] });
      },
    );
  };

  private initLogoList = () => {
    const { model } = this.props;

    this.setState({
      logoList: model.get('logo')
        ? [{ name: model.get('logo.mediaFileName'), uid: model.get('logo.@id') }]
        : [],
    });
  };

  private onRemove = () => {
    this.formRef.current?.resetFields(['logo']);
    this.setState({ logoList: [] });
  };
}

export default AdvertiserForm;
